export const customStyleMap = {
  textAlignJustify: {
    textAlign: 'justify',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
  },
};



// WEBPACK FOOTER //
// ./src/component/TextEditor/customStyleMap.js